import { mapState, mapGetters } from 'vuex';

import HeaderDefault from '@/components/_core/ui/header/index.vue';
import MenuSidebarDefault from '@/components/_core/ui/menu-sidebar/index.vue';
import Snackbar from '@/components/_core/ui/snackbar/index.vue';
import ImpersonatedLayout from '@/components/_core/ui/impersonated';

export default {
  components: {
    HeaderDefault,
    MenuSidebarDefault,
    Snackbar,
    ImpersonatedLayout
  },
  head() {
    return {
      title         : this.headTitle,
      titleTemplate : `%s :: ${process.env.APPLICATION_TITLE}`,
      meta          : [
        { name: 'theme-color', content: this.themes.light.primary },
        { name: 'msapplication-navbutton-color', content: this.themes.light.primary },
        { name: 'apple-mobile-web-app-status-bar-style', content: this.themes.light.primary }
      ]
    };
  },
  data() {
    return {
      type               : 'authenticated',
      receivedShowMobile : false,
      configBorder       : '',
      fluid              : false,
      statusMini         : false,
      stateMenuMobile    : false,
      selectedContent    : [],
      filter             : true
    };
  },
  created() {
    this.$vuetify.theme.themes.light.primary   = this.themes.light.primary;
    this.$vuetify.theme.themes.light.secondary = this.themes.light.secondary;
    this.$vuetify.theme.themes.light.accent    = this.themes.light.accent;
    this.$root.$i18n.locale                    = this.user.languageId;
  },
  computed: {
    ...mapGetters({
      dark           : '_core/application/isDark',
      showContent    : '_core/auth/isAuthenticated' && '_core/auth/hasCurrentRole',
      isImpersonated : '_core/auth/isImpersonated'
    }),
    ...mapState({
      themes        : state => state._core.application.themes,
      tenantsRights : state => state._core.auth.tenantsRights,
      user          : state => state._core.user,
      snackbar      : state => state._core.application.snackbar
    }),
    headTitle() {
      return this.$t('common.loading');
    },
    applicationThemes() {
      return this.themes;
    }
  },
  watch: {
    statusMini() {
      this.fluid = !this.fluid;
      this.configBorder = this.fluid ? 'px-0' : '';
    },
    stateMenuMobile() {
      this.receivedShowMobile = this.stateMenuMobile;
    }
  }
};
